import './App.css';
import { baseUrl, fileSystemUrl, socketUrl } from './constants/Connections';
import StatusItem from './StatusItem';
import image from './assets/images/alkalma.png';
import { useState, useCallback } from 'react';

function App() {
	const [completedCount, setCompletedCount] = useState(0);

	const serverHeader = {
		Authorization: `this is random token`,
	};

	const endpoints = [
		{
			header: serverHeader,
			whitelistText: baseUrl,
			url: `${baseUrl}/health`,
			method: 'GET',
			loadingText: 'Reaching server...',
			successText: 'Server is reached!',
			errorText: `Server couldn't be reached.`,
		},
		{
			header: { withCredentials: true },
			whitelistText: socketUrl,
			url: `${socketUrl}/healthcheck`,
			method: 'GET',
			loadingText: 'Reaching web socket server...',
			successText: 'Web socket server is reached!',
			errorText: `Web socket server couldn't be reached.`,
		},
		{
			header: null,
			whitelistText: fileSystemUrl,
			url: `${fileSystemUrl}/public/alkalma_education_logo.png`,
			method: 'GET',
			loadingText: 'Reaching file system...',
			successText: 'File system server is reached!',
			errorText: `File system couldn't be reached.`,
		},
		{
			header: null,
			whitelistText: `https://student.alkalmaup.com`,
			url: `https://student.alkalmaup.com/asset-manifest.json`,
			method: 'GET',
			loadingText: "Reaching student's web app...",
			successText: "Student's web app is reached!",
			errorText: `Student's web app couldn't be reached.`,
		},
		{
			header: null,
			whitelistText: `https://web.alkalmaup.com`,
			url: `https://web.alkalmaup.com/asset-manifest.json`,
			method: 'GET',
			loadingText: "Reaching staff's web app...",
			successText: "Staff's web app is reached!",
			errorText: `Staff's web app couldn't be reached.`,
		},
	];

	const handleStatusComplete = useCallback(() => {
		setCompletedCount((prev) => Math.min(prev + 1, endpoints.length));
	}, []);

	const progressPercentage = (completedCount / endpoints.length) * 100;

	return (
		<div className='App'>
			<img src={image} alt='AlkalmaUp Education Logo' className='image' loading='lazy' />
			<p className='app-subtitle'>This tool verifies your network setup for the AlkalmaUp app. Please ensure all connections are successful before proceeding.</p>

			<div className='status-container'>
				<div className='progress-header'>
					Connection Status ({completedCount}/{endpoints.length} complete)
				</div>
				<div className='progress-bar'>
					<div className='progress-fill' style={{ width: `${progressPercentage}%` }}></div>
				</div>

				{endpoints.map((props, idx) => (
					<StatusItem key={idx} {...props} onComplete={handleStatusComplete} />
				))}
			</div>

			<div className='mail-text'>
				📧 Don't forget to add <b>@alkalmahealth.com</b> to your email whitelist!
			</div>
		</div>
	);
}

export default App;
